import "c3/c3.css"

import prepareComponent from "@bluframe/grapple/prepareComponent"
import c3 from "c3"
import * as d3 from "d3"
import { RefObject, useEffect, useRef } from "react"
import theme from "styles/theme"

import Chart from "./Chart"

export interface Props {
  ariaLabel?: string
  data: { date: string; newUsers: number }[]
}

export interface ComponentProps extends Omit<Props, "data"> {
  chartRef: RefObject<HTMLDivElement | null>
}

export const usePrepareComponent = ({
  data,
  ...props
}: Props): ComponentProps => {
  // Ref to attach the chart
  const chartRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!chartRef.current) return

    // Generate the chart
    const chart = c3.generate({
      axis: {
        // eslint-disable-next-line id-length
        x: {
          tick: {
            format(date) {
              return d3.timeFormat("%e %b")(date as Date)
            }
          },
          type: "timeseries"
        },
        // eslint-disable-next-line id-length
        y: {
          show: false
        }
      },
      bindto: chartRef.current,
      data: {
        colors: { newUsers: theme.palette!.primary!.main },
        json: data,
        keys: {
          value: ["newUsers"],
          // eslint-disable-next-line id-length
          x: "date"
        },
        names: {
          newUsers: "New Users"
        },
        type: "bar"
      },
      size: {
        height: 200,
        width: 440
      },
      tooltip: {
        format: {
          value: (value) => value as string
        }
      }
    })

    // Cleanup on component unmount
    // eslint-disable-next-line consistent-return
    return () => {
      chart.destroy()
    }
  }, [data])

  return {
    ...props,
    chartRef
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  Chart
)
